export default import.meta.ROLLUP_FILE_URL_CpoR4$y7